// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-csat-rating-current {
  display: flex;
  align-items: center;
  background: #fffaf5;
  box-shadow:
    0px 0px 1px 0px #00000040,
    0px 2px 1px 0px #0000000d;
}

.BC-csat-rating-current .rating-form {
  padding: 16px;
  flex-grow: 1;
  min-height: 130px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.BC-csat-rating-current .rating-form .title {
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: 600;
}

.BC-csat-rating-current .rating-form .subtitle {
  margin-bottom: 8px;
}

.BC-csat-rating-current .rating-form .star-container {
  display: flex;
  align-items: center;
  gap: 7.5px;
}

.BC-csat-rating-current .rating-form .star-container .rating-star {
  cursor: pointer;
  width: 32px;
  height: 32px;
}

.BC-csat-rating-current .rating-form .star-container .rating-star.rating-star--hover path {
  fill: #f9b23a;
  opacity: 1;
}

.BC-csat-rating-current .rating-form .star-container .rating-star.rating-star--selected path {
  fill: #f9b23a;
  opacity: 1;
}

.BC-csat-rating-current .rating-img {
  width: 218px;
  height: 126px;
  object-fit: cover;
  flex-shrink: 0;
}

.BC-csat-rating-current .rating-img.rating-img--large {
  height: 134px;
}

.BC-csat-rating-current .Feedback__Action {
  margin-top: 12px;
  display: flex;
  gap: 8px;
}

/* Onboarding */

.BC-Page.BC-Page__DashboardV3 .ob-rating-container {
  display: flex;
  align-items: center;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form {
  padding: 16px;
  flex-grow: 1;
  min-height: 103px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .title {
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: 600;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .subtitle {
  margin-bottom: 8px;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container {
  display: flex;
  align-items: center;
  gap: 7.5px;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star {
  cursor: pointer;
  width: 32px;
  height: 32px;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star path {
  fill: #003d2c;
}

.BC-Page.BC-Page__DashboardV3
  .ob-rating-container
  .rating-form
  .star-container
  .rating-star.rating-star--hover
  path {
  fill: #f9b23a;
  opacity: 1;
}

.BC-Page.BC-Page__DashboardV3
  .ob-rating-container
  .rating-form
  .star-container
  .rating-star.rating-star--selected
  path {
  fill: #f9b23a;
  opacity: 1;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-img {
  width: 160px;
  height: 103px;
  object-fit: cover;
}

.BC-Page.BC-Page__DashboardV3 .ob-rating-container .Feedback__Action {
  margin-top: 12px;
  display: flex;
  gap: 8px;
}

/* Reverse trial expired */

.BC-ReverseTrialExpired {
  margin-top: 40px;
}

.BC-ReverseTrialExpired .Polaris-DisplayText {
  margin-bottom: 20px;
}

.BC-ReverseTrialExpired__Banner {
  margin-bottom: 20px;
}

.BC-ReverseTrialExpired__Columns {
  display: flex;
}

.BC-ReverseTrialExpired__Column {
  flex: 1;
  min-width: 0;
  padding: 20px;
}

.BC-ReverseTrialExpired__Divider {
  width: 1px;
  margin: 0;
  background-image: linear-gradient(var(--p-divider) 50%, transparent 0%);
  background-size: 1px 8px;
  background-repeat: repeat-y;
}

.BC-ReverseTrialExpired__ColumnTitle {
  display: block;
  margin-bottom: 16px;
}

.BC-ReverseTrialExpired__ColumnTitle.available {
  font-weight: 600;
  font-size: 14px;
  color: var(--p-text-success);
}

.BC-ReverseTrialExpired__ColumnTitle.paused {
  font-weight: 600;
  font-size: 14px;
  color: var(--p-text-subdued);
}

.BC-ReverseTrialExpired__List {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.BC-ReverseTrialExpired__List li {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 8px;
  margin-bottom: 12px;
  text-align: left;
}

.BC-ReverseTrialExpired__List li img {
  margin-top: 2px;
}

.BC-ReverseTrialExpired__List li .Polaris-Icon {
  margin: 0;
  flex-shrink: 0;
}

.BC-ReverseTrialExpired__List li:last-child {
  margin-bottom: 0;
}

.BC-ReverseTrialExpired__Unlock {
  margin-top: 20px;
  padding: 16px;
  border-radius: var(--p-border-radius-2);
  background: var(--p-surface-success-subdued);
}

.BC-ReverseTrialExpired__Unlock .Polaris-Subheading {
  color: #202223;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 8px;
}

.BC-ReverseTrialExpired__Unlock p {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}

.BC-ReverseTrialExpired__Unlock a {
  font-size: 14px;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/styles/dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB;;6BAE2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA,eAAe;;AAEf;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,aAAa;EACb,UAAU;AACZ;;AAEA;;;;;;EAME,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA,0BAA0B;;AAE1B;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uEAAuE;EACvE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".BC-csat-rating-current {\n  display: flex;\n  align-items: center;\n  background: #fffaf5;\n  box-shadow:\n    0px 0px 1px 0px #00000040,\n    0px 2px 1px 0px #0000000d;\n}\n\n.BC-csat-rating-current .rating-form {\n  padding: 16px;\n  flex-grow: 1;\n  min-height: 130px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.BC-csat-rating-current .rating-form .title {\n  margin-bottom: 4px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.BC-csat-rating-current .rating-form .subtitle {\n  margin-bottom: 8px;\n}\n\n.BC-csat-rating-current .rating-form .star-container {\n  display: flex;\n  align-items: center;\n  gap: 7.5px;\n}\n\n.BC-csat-rating-current .rating-form .star-container .rating-star {\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n}\n\n.BC-csat-rating-current .rating-form .star-container .rating-star.rating-star--hover path {\n  fill: #f9b23a;\n  opacity: 1;\n}\n\n.BC-csat-rating-current .rating-form .star-container .rating-star.rating-star--selected path {\n  fill: #f9b23a;\n  opacity: 1;\n}\n\n.BC-csat-rating-current .rating-img {\n  width: 218px;\n  height: 126px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.BC-csat-rating-current .rating-img.rating-img--large {\n  height: 134px;\n}\n\n.BC-csat-rating-current .Feedback__Action {\n  margin-top: 12px;\n  display: flex;\n  gap: 8px;\n}\n\n/* Onboarding */\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container {\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form {\n  padding: 16px;\n  flex-grow: 1;\n  min-height: 103px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .title {\n  margin-bottom: 4px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .subtitle {\n  margin-bottom: 8px;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container {\n  display: flex;\n  align-items: center;\n  gap: 7.5px;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star {\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-form .star-container .rating-star path {\n  fill: #003d2c;\n}\n\n.BC-Page.BC-Page__DashboardV3\n  .ob-rating-container\n  .rating-form\n  .star-container\n  .rating-star.rating-star--hover\n  path {\n  fill: #f9b23a;\n  opacity: 1;\n}\n\n.BC-Page.BC-Page__DashboardV3\n  .ob-rating-container\n  .rating-form\n  .star-container\n  .rating-star.rating-star--selected\n  path {\n  fill: #f9b23a;\n  opacity: 1;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .rating-img {\n  width: 160px;\n  height: 103px;\n  object-fit: cover;\n}\n\n.BC-Page.BC-Page__DashboardV3 .ob-rating-container .Feedback__Action {\n  margin-top: 12px;\n  display: flex;\n  gap: 8px;\n}\n\n/* Reverse trial expired */\n\n.BC-ReverseTrialExpired {\n  margin-top: 40px;\n}\n\n.BC-ReverseTrialExpired .Polaris-DisplayText {\n  margin-bottom: 20px;\n}\n\n.BC-ReverseTrialExpired__Banner {\n  margin-bottom: 20px;\n}\n\n.BC-ReverseTrialExpired__Columns {\n  display: flex;\n}\n\n.BC-ReverseTrialExpired__Column {\n  flex: 1;\n  min-width: 0;\n  padding: 20px;\n}\n\n.BC-ReverseTrialExpired__Divider {\n  width: 1px;\n  margin: 0;\n  background-image: linear-gradient(var(--p-divider) 50%, transparent 0%);\n  background-size: 1px 8px;\n  background-repeat: repeat-y;\n}\n\n.BC-ReverseTrialExpired__ColumnTitle {\n  display: block;\n  margin-bottom: 16px;\n}\n\n.BC-ReverseTrialExpired__ColumnTitle.available {\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--p-text-success);\n}\n\n.BC-ReverseTrialExpired__ColumnTitle.paused {\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--p-text-subdued);\n}\n\n.BC-ReverseTrialExpired__List {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n}\n\n.BC-ReverseTrialExpired__List li {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  gap: 8px;\n  margin-bottom: 12px;\n  text-align: left;\n}\n\n.BC-ReverseTrialExpired__List li img {\n  margin-top: 2px;\n}\n\n.BC-ReverseTrialExpired__List li .Polaris-Icon {\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.BC-ReverseTrialExpired__List li:last-child {\n  margin-bottom: 0;\n}\n\n.BC-ReverseTrialExpired__Unlock {\n  margin-top: 20px;\n  padding: 16px;\n  border-radius: var(--p-border-radius-2);\n  background: var(--p-surface-success-subdued);\n}\n\n.BC-ReverseTrialExpired__Unlock .Polaris-Subheading {\n  color: #202223;\n  font-size: 12px;\n  font-weight: 400;\n  margin-bottom: 8px;\n}\n\n.BC-ReverseTrialExpired__Unlock p {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.BC-ReverseTrialExpired__Unlock a {\n  font-size: 14px;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
